import * as Yup from 'yup';

import { EMAIL_VALIDATION } from '~constants/validations';

export const VALIDATION_SCHEMA = Yup.object().shape({
  email: EMAIL_VALIDATION
});

export const hasChanged = (initialEmail, currentEmail) => initialEmail !== currentEmail;
